// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Login_background_1t0HY{position:relative;width:100%;min-height:100vh;background-color:#f2f2f2}", ""]);
// Exports
exports.locals = {
	"background": "Login_background_1t0HY"
};
module.exports = exports;
